import { render, staticRenderFns } from "./inputPassword.vue?vue&type=template&id=45365355&scoped=true"
import script from "./inputPassword.vue?vue&type=script&lang=js"
export * from "./inputPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45365355",
  null
  
)

export default component.exports